<template>
    <div class="container">
        <div class="title-div">
            <div class="title">
                <p>No busques más.<br>
                    El desarrollador que tu empresa necesita<br> está aquí.</p>
            </div>
        </div>
        <div class="container-tbody">
            <div class="img-left">
                <img src="/external/rectangle71026-kds-300h.png" alt="Rectangle71026" class="frame-rectangle7" />
            </div>
            <div class="text-tbody">
                <p>
                    En Ademass podrás acceder a una de las mayores comunidades de perfiles 
                    tecnológicos para cubrir cualquier puesto laboral.
                    <br>
                    <br>
                    Una solución rápida y gratuita para facilitar la
                    contratación de desarrolladores tecnológicos.
                </p>

            </div>
        </div>
    </div>
</template>

<script  setup>
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}

.title-div {
    color: rgba(46, 163, 242, 1);
    height: auto;
    font-size: 60px;
    font-style: Black;
    text-align: center;
    font-family: Darker Grotesque;
    font-weight: 900;
    line-height: 94.9999988079071%;

}

.title {
    color: rgba(46, 163, 242, 1);
}

.text-tbody {
    height: 100%;
    margin-left: 30px;
    color: rgba(39, 52, 68, 1);
    max-width: 400px;
    font-size: 24px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
}

.container-tbody {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.frame-rectangle7 {
    border-radius: 15px;
    box-shadow: -30px -30px 0 0 #8F8181;
    top: 10px;
    left: 10px;
}

@media screen and (max-width: 900px) {
    .container {
        margin-bottom: 0;
    }

    .container-tbody {
        flex-direction: column;
        margin-bottom: 0;
    }

    .img-left {
        margin-top: 0;
        max-width: 100%;
        overflow: hidden;
    }

    .img-left img {
        width: 95%;
        height: auto;
        display: block;
        margin-left: 1.2%;

    }

    .text-tbody {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        padding-bottom: 0;
        margin-left: 0;
        width: 85%;
        margin-bottom: 0;
    }

    .title-div {
        padding: 15px;
        margin-left: 0;
        font-weight: 900;
        font-size: 55px;
    }

    .frame-rectangle7 {
        box-shadow: 0px 0px 0 0 #8F8181;
    }
}</style>